import Particle from "particle-api-js";

export default new Particle();



/** WEBPACK FOOTER **
 ** ./src/lib/particle.js
 **/